import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

export default function OrgSwitcher() {
  const { orgs, currentOrg, switchOrg } = useAuth();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, []);
  if (!orgs?.length) return null;
  return (
    <div style={{ position: "relative", minWidth: 0 }} onClick={(e) => e.stopPropagation()} data-testid="org-switcher">
      <button
        className="qw-btn"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        title={currentOrg?.name || ""}
        data-testid="org-switcher-btn"
      >
        <span style={{ width: 8, height: 8, borderRadius: 99, background: "#0f766e", flex: "none" }} aria-hidden="true" />
        <span className="qw-org-name">{currentOrg?.name || "—"}</span>
        <span style={{ opacity: .5, flex: "none" }} aria-hidden="true">▾</span>
      </button>
      {open && (
        <div className="qw-dropdown qw-dropdown-org" data-testid="org-switcher-menu">
          {orgs.map((o) => (
            <div key={o.id} className={"item " + (o.id === currentOrg?.id ? "unread" : "")} onClick={() => { switchOrg(o.id); setOpen(false); }} data-testid={`org-option-${o.id}`}>
              <div style={{ fontWeight: 600 }}>{o.name}</div>
              <div style={{ fontSize: 11, color: "#64748b" }}>{o.role === "owner" ? "Собственик" : "Продажби"}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
